import React, { useEffect, useMemo, useState } from 'react';
import './UserAvatar.css';

const apiOrigin = () => {
  const api = window.__CRM_API__ || `${window.location.origin}/api`;
  try { return new URL(api, window.location.origin).origin; }
  catch { return window.location.origin; }
};

export const resolveAvatarUrl = (value) => {
  if (!value) return null;
  try { return new URL(value, `${apiOrigin()}/`).toString(); }
  catch { return null; }
};

const initialsFor = (person) => [person?.nombre?.[0], person?.apellido?.[0]].filter(Boolean).join('').toUpperCase() || 'QL';
const hueFor = (person) => Array.from(`${person?.email || ''}${person?.nombre || ''}`).reduce((total, letter) => total + letter.charCodeAt(0), 205) % 360;

export default function UserAvatar({ person, className = '', alt }) {
  const source = resolveAvatarUrl(person?.avatar_url);
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [source]);
  const hue = useMemo(() => hueFor(person), [person]);
  const label = alt || `Foto de ${[person?.nombre, person?.apellido].filter(Boolean).join(' ') || 'usuario'}`;

  return <span className={`profile-avatar ${className}`.trim()} style={{ '--avatar-hue': hue }}>
    {source && !failed
      ? <img src={source} alt={label} onError={() => setFailed(true)} />
      : <span className="profile-avatar-fallback" aria-label={`Avatar genérico de ${label.replace(/^Foto de /, '')}`}>{initialsFor(person)}</span>}
  </span>;
}
